export default __webpack_public_path__ + "static/media/img1.75285f27.png";